import {
  deleteTimeSlotBookingReq,
  getMobileUserBookingsReq,
} from "@/api/services/user-bookings";
import { userBookingsStore } from "../store";
import { AxiosError } from "axios";

export const useUserBookings = () => {
  const getUserBookings = async () => {
    userBookingsStore.getState().setLoading(true);
    try {
      const response = await getMobileUserBookingsReq();
      if (response.status === 200 && response.data) {
        userBookingsStore.getState().setUserBookings(response.data);
      } else {
        userBookingsStore.getState().setError("Error fetching user bookings");
      }
    } catch (error: unknown) {
      if (error instanceof AxiosError) {
        userBookingsStore
          .getState()
          .setError(
            error.response?.data?.message || "Error fetching user bookings"
          );
      } else {
        userBookingsStore.getState().setError("Error fetching user bookings");
      }
    } finally {
      userBookingsStore.getState().setLoading(false);
    }
  };

  const deleteBookingTimeSlot = async (
    userBookingId: number,
    bookingTimeSlotId: number
  ) => {
    userBookingsStore.getState().deleteBookingTimeSlot();
    try {
      await deleteTimeSlotBookingReq(bookingTimeSlotId);
      userBookingsStore
        .getState()
        .deleteBookingTimeSlotSuccess(userBookingId, bookingTimeSlotId);
    } catch (error: unknown) {
      if (error instanceof AxiosError) {
        userBookingsStore
          .getState()
          .setError(
            error.response?.data?.message || "Error deleting booking time slot"
          );
      } else {
        userBookingsStore
          .getState()
          .setError("Error deleting booking time slot");
      }
    } finally {
      userBookingsStore.getState().setLoading(false);
    }
  };

  return {
    getUserBookings,
    deleteBookingTimeSlot,
  };
};
